// An organization as a small chip: the round flag of its home country where
// one is on record, its name, and its part where one is given
import { Box, Chip, SxProps, Theme } from "@mui/material";
import React from "react";

import { CountryFlag } from "./CountryFlag";

interface OrganizationChipProps {
  name: string;
  // Its home country's ISO code; no flag is drawn for none
  country?: string | null;
  // Its part, after its name: "lead", "developer"
  role?: string | null;
  // Makes the chip a button; without it the chip is plain text
  onClick?: () => void;
  sx?: SxProps<Theme>;
}

export const OrganizationChip: React.FC<OrganizationChipProps> = ({
  name,
  country = null,
  role = null,
  onClick,
  sx,
}) => (
  <Chip
    size="small"
    variant="outlined"
    icon={
      country ? (
        // The chip gives its icon's margins by a class, which the flag does
        // not take itself
        <Box component="span" sx={{ display: "inline-flex" }}>
          <CountryFlag code={country} size={12} round />
        </Box>
      ) : undefined
    }
    label={
      <>
        {name}
        {role && (
          <Box component="span" sx={{ color: "text.secondary" }}>
            {" "}
            · {role}
          </Box>
        )}
      </>
    }
    onClick={onClick}
    sx={[
      { height: 22, fontSize: "11.5px", "& .MuiChip-icon": { ml: 1, mr: -0.25 } },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  />
);

export default OrganizationChip;
